import type { CampagneNewsletter } from '../../api/newsletter.js';
/** Part des délivrés, en pourcentage entier ; `null` tant que rien n'est délivré. */
export function tauxSur(valeur: number, delivres: number): number | null {
  return delivres ? Math.round((valeur / delivres) * 100) : null;
}
export function formaterTaux(taux: number | null): string {
  return taux === null ? '—' : `${taux} %`;
}
/** Taux moyen pondéré par les délivrés des campagnes qui ont un relevé. */
export function tauxMoyen(
  campagnes: CampagneNewsletter[],
  cle: 'ouvertures' | 'clics',
): number | null {
  let valeur = 0;
  let delivres = 0;
  for (const c of campagnes) {
    if (!c.statistiques?.delivres) continue;
    valeur += c.statistiques[cle];
    delivres += c.statistiques.delivres;
  }
  return tauxSur(valeur, delivres);
}
